// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';
import ComparisonItem from '@/types/comparison-item';
import Icon from '../common/Icon';

type Props = {
  value?: string;
  className?: string;
  id?: string;
  item?: ComparisonItem;
  color?: string;
};

const ProposalFieldLabelCell: React.FunctionComponent<Props> = ({ value, className, item, id, color }: Props) => {
  if (value == null) {
    return <NoDataCell item={item} id={id} />;
  }

  return (
    <div className={classNames('cell proposal-field-label-cell', className)} id={id ? `cell-${id}` : undefined}>
      <span className="markup-container" data-private data-dd-privacy="mask">
        {color && (
          <div className="no-shrink">
            <Icon className="pdf-ignore" type="icon-circle" size={10} boxPad={100} color={color} decorative margin="0 6px 0 4px" />
          </div>
        )}
        {value}
      </span>
    </div>
  );
};

export default ProposalFieldLabelCell;
